import { Component, OnInit, ElementRef, ViewChild, ViewChildren, QueryList, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseQuestionnaireModel, Model, QuestionnaireModel, QuestPage, eAppContext } from '../../models';
import { CoreService, HttpService } from '../../services';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';
import { isEmptyStr } from '../../utilities';
import { TagComponent } from '../../tag';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-modelcreation',
  templateUrl: './ModelCreation.component.html',
  styleUrls: ['./modelCreation.component.css']
})

export class ModelCreationComponent implements OnInit {

  // #region constructeur
  constructor(
    protected indParam: CoreService,
    protected activatedRouter: ActivatedRoute,
    protected router: Router,
    protected service: HttpService,
    protected elementHtml: ElementRef,
    protected dialogservice: DialogService,
    protected toastservice: ToastService
  ) { }
  // #endregion

  // #region variables globales

  public model: BaseQuestionnaireModel = new BaseQuestionnaireModel;
  public point: any;
  public titre: string;
  public titreDelete: string;
  public modelName: string;
  public CanBeConverted: Boolean;
  public description: string;
  public messageFin: string;
  public IdQuest: string;

  public titreOK: boolean;
  textError: string;
  public questionnaireType: number = 0;
  public modeQuest: boolean;
  public filterType: string;

  public listModelFilter: Array<Model> = new Array<Model>();
  public filter: string;

  public kebabClickable: boolean = false;

  public isFromeEL: boolean;

  // Modal open btn
  @ViewChild('ModalCloneBtn', { static: false }) ModalCloneBtn: ElementRef;
  @ViewChild('ModalDeteleBtn', { static: false }) ModalDeteleBtn: ElementRef;
  // Modal close btn
  @ViewChild('CloseClone', { static: false }) CloseClone: ElementRef;
  @ViewChild('CloseDelete', { static: false }) CloseDelete: ElementRef;
  @ViewChild('CloseCreate', { static: false }) CloseCreate: ElementRef;
  @ViewChild('CloseConvertion', { static: false }) CloseConvertion: ElementRef;


  @ViewChildren('kebabDropdown') kebabDropdown: QueryList<ElementRef>;

  @ViewChild(TagComponent, { static: false }) tagComp: TagComponent;
  public pathPageCreateQuestionnaire: string;

  @Input()
  set pathCreateQuestionnaire(value: string) {
    // tslint:disable-next-line:no-null-keyword
    if (value != null) {
      this.pathPageCreateQuestionnaire = value;
    }
  }

  // #endregion

  // #region cycle de vie
  ngOnInit(): void {
    // recuperation de la liste des model de questionanire
    this.ListModel();

    this.isFromeEL = this.indParam.Context === eAppContext.ELEARNING;

    this.dialogservice.showSplash(true);
    this.model.Mode = 'updateOldRep';
    this.service.postHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/`, this.model).subscribe((dataUpdate: BaseQuestionnaireModel) => {
      if (!dataUpdate.HasError) {
        this.ListModel();
      }
    });
    this.dialogservice.showSplash(false);
  }
  // #endregion

  // #region public functions

  // #region LISTMODEL
  ListModel(): void {
    this.dialogservice.showSplash(true);
    this.service.getHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/LISTMODEL/0/`).subscribe((dataGet: BaseQuestionnaireModel) => {
      if (!dataGet.HasError) {
        this.model = dataGet;
        this.listModelFilter = dataGet.listModel;
        let modelDefault: Model = new Model();
        this.listModelFilter.unshift(modelDefault);

        if (localStorage.getItem('FilterModel')) {
          this.filter = String(localStorage.getItem('FilterModel'));
          localStorage.removeItem('FilterModel');
          this.filterQuestionnairesList();


        } else { this.filter = ''; }

        this.dialogservice.showSplash(false);
      } else {
      }
    });
  }
  // #endregion

  // #region DELETE
  // Open modal Detele
  DeleteModel(IdQuest: string): void {
    //this.modelName = model;
    //this.titreDelete = titre;
    this.IdQuest = IdQuest;
    this.service.getHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/STAGEBYMODEL/${IdQuest}/`).subscribe((ListStage: BaseQuestionnaireModel) => {
      if (!ListStage.HasError) {
        this.model.StageByModel = ListStage.StageByModel;
      }
    });
    this.ModalDeteleBtn.nativeElement.click();
  }

  ValideDelete(): void {
    this.dialogservice.showSplash(true);
    // tslint:disable-next-line:max-line-length
    this.service.getHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/DELETE/${this.IdQuest}/`).subscribe((dataDelete: BaseQuestionnaireModel) => {
      if (!dataDelete.HasError) {
        this.toastservice.showInfoToast(this.indParam.getTrad('modelisdeleted_QU'));
        this.ListModel();
        this.CloseDelete.nativeElement.click();
        this.dialogservice.showSplash(false);
      } else {
      }
    });
  }
  // #endregion

  // #region CREATE
  creatNewModel(): void {
    // test si le titre ne contient pas de caractères spécial
    this.titreOK = (this.titre === '' || this.titre === undefined) ? false : true;
    if (this.titreOK) {

      if (this.alreadyExist(this.titre)) {
        this.toastservice.showWarningToast(this.indParam.getTrad('Amodelwiththesamenameexists_QU'));
      } else {


        this.textError = '';
        const questionnaire: QuestionnaireModel = new QuestionnaireModel();
        questionnaire.description = this.description;
        questionnaire.titre = this.titre;

        questionnaire.notePassage = this.point;
        questionnaire.messageFin = this.messageFin;
        questionnaire.pagination = new Array<QuestPage>();
        questionnaire.isElearning = this.modeQuest;
        questionnaire.questionnaireType = this.questionnaireType;

        this.model.questionnaireModel = questionnaire;
        this.model.Mode = 'send';
        this.service.postHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/`, this.model).subscribe((dataCreate: BaseQuestionnaireModel) => {
          if (!dataCreate.HasError) {
            this.ListModel();
            this.titre = '';
            this.description = '';
            this.messageFin = '';
            this.point = '';
            this.toastservice.showSuccessToast(this.indParam.getTrad('questionnaireiscreated_QU'));
            this.CloseCreate.nativeElement.click();
            // redirection vers le questionnaire créé
            this.goToCreateQuestionnaire(dataCreate.questionnaireModel.ident);
          }
        });
      }

    } else {
      this.toastservice.showWarningToast(this.indParam.getTrad('Invalidmodelname_QU'));
    }

  }
  // #endregion

  // #region CLONE
  // Open modal clone
  CloneModel(model: string, CanBeConverted: boolean): void {
    this.CanBeConverted = CanBeConverted;
    this.modelName = model;
    this.ModalCloneBtn.nativeElement.click();
  }

  ValideClone(): void {
    // test si le titre ne contient pas de caractères spécial
    this.titreOK = (this.titre === '' || this.titre === undefined) ? false : true;
    if (this.titreOK) {
      if (this.alreadyExist(this.titre)) {
        this.toastservice.showWarningToast(this.indParam.getTrad('Amodelwiththesamenameexists_QU'));
      } else {
        this.dialogservice.showSplash(true);
        // tslint:disable-next-line:max-line-length


        let model: BaseQuestionnaireModel = new BaseQuestionnaireModel;
        model.Mode = 'CLONE';
        model.questionnaireModel.questionnaireType = this.questionnaireType;
        model.questionnaireModel.ident = this.modelName;
        model.questionnaireModel.titre = this.titre;
        this.service.postHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/`, model).subscribe((dataDelete: BaseQuestionnaireModel) => {
          if (!dataDelete.HasError) {
            this.titre = '';
            this.modeQuest = false;
            this.questionnaireType = 0;
            this.toastservice.showInfoToast(this.indParam.getTrad('questionnaireisclone_QU'));
            this.ListModel();
            this.CloseClone.nativeElement.click();
            this.dialogservice.showSplash(false);
          }
        });
      }
    } else {
      this.toastservice.showWarningToast(this.indParam.getTrad('Invalidmodelname_QU'));
    }
  }
  // #endregion

  // #region NAVIGATION
  goback(): void {
    this.router.navigate(['webform/elearning/home']);
  }

  // retour a la page creation du questionnaire
  goToCreateQuestionnaire(model: string): void {
    // envoi des informations du nom du model a la page de creation du questionnaire
    if (!this.kebabClickable) {
      this.router.navigate([`${this.pathPageCreateQuestionnaire}`], { queryParams: { 'modelIdent': model }, skipLocationChange: true });
    }
  }
  // #endregion

  // #region FILTER
  // Filtre sur la liste des modèles de questionnaire 
  filterQuestionnairesList(): void {
    this.tagComp.clearSelectedTag(false);
    this.listModelFilter = new Array<Model>();
    if (this.filter) {
      this.listModelFilter = this.model.listModel.filter((el) => (el.titre.toUpperCase().includes(this.filter.toUpperCase()) || el.ident === '0')).sort();
    } else {
      this.listModelFilter = this.model.listModel
    }
  }

  // Filtre sur la liste des modèles de questionnaire par type de questionnaire
  filterQuestionnairesType(type: string): void {
    this.filterType = type;
  }


  public filterByTag(event: any): void {
    this.filter = '';
    if (event.length > 0) {
      this.listModelFilter = this.model.listModel.filter((el) => event.includes(el.ident) || el.ident === '0').sort();
    } else {
      this.listModelFilter = this.model.listModel
    }
  }
  // #endregion

  // #region KEBAB
  clickKebab(i: any, e: any, clicked?: boolean): void {
    e.stopPropagation();
    const Kebab: any = this.kebabDropdown.toArray().filter((r: any) => r.nativeElement.hasAttribute('data-index'))[i];
    if (Kebab.nativeElement.classList.contains('active')) {
      Kebab.nativeElement.classList.toggle('active');
      this.kebabClickable = false;
    } else if (clicked) {
      Kebab.nativeElement.classList.toggle('active');
      this.kebabClickable = true;
    }
  }

  // #endregion


  updateModel(): void {
    this.dialogservice.showSplash(true);
    this.model.Mode = 'updateOldModel';
    this.service.postHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/`, this.model).subscribe((dataUpdate: BaseQuestionnaireModel) => {
      if (!dataUpdate.HasError) {
        this.ListModel();
        this.dialogservice.showSplash(false);
      }
    });
    this.CloseConvertion.nativeElement.click();

  }

  public switchMode(idMode: number = -1, model: Model = new Model()) {

    if (idMode == -1) {
      this.toastservice.showWarningToast(this.indParam.getTrad('Typecantchange'));
    } else {
      model.questionnaireType = idMode;
      this.service.getHttp<BaseQuestionnaireModel>(`${this.indParam.AppParams.apiUrl}api/Model/UPDATEMODE/${model.ident}|${idMode}/`).subscribe((dataMode: BaseQuestionnaireModel) => {
        if (!dataMode.HasError) {
        }
      });


    }
  }


  // #endregion

  // #region private functions

  // Pas de caractère spéciaux dans le titre du questionnaire
  private isTitreQuestOk(titre: string): boolean {
    const regex: RegExp = /[$&+,:;=?@#|'<>.^*%!-]/g;
    let result: boolean = true;
    if (!isEmptyStr(titre)) {
      if (titre.match(regex) !== null) {
        this.textError = `${this.indParam.getTrad('specialscharacters_QU')} ${titre.match(regex)} ${this.indParam.getTrad('notallowadforthemodeltitle_QU')}`;
        // this.indParam.showAlertToast(this.textError);
        result = false;
      }
    }
    return result;
  }

  // check if model exist
  private alreadyExist(titre: string): boolean {
    let AlreadyExist: boolean = false;
    this.listModelFilter.forEach((model: Model) => {
      const mTitre: string = model.titre.replace(/\s/g, '').toLowerCase();
      const tTitre: string = titre.replace(/\s/g, '').toLowerCase();
      if (mTitre === tTitre) {
        AlreadyExist = true;
      }
    });
    return AlreadyExist;
  }

  // #endregion

}
